module.exports = __webpack_public_path__ + "font/e1794822.svg";